import React, { FC } from 'react';
import { Drawer, DrawerProps } from '@mui/material';
import Button, { ButtonSize } from '../Form/Button/Button';
import { Theme } from '../types/enums';
import { Checkbox } from '../Form';
import './DashboardDrawer.scss';

export interface CheckboxOption {
  label: string;
  checked: boolean;
}

interface DashboardDrawerFormProps extends DrawerProps {
  open?: boolean;
  title?: string;
  filterIndex?: number;
  buttonLabel?: string;
  disabledButton?: boolean;
  hideCloseButton?: boolean;
  onClose?: () => void;
  buttonOnClick?: () => void;
  children?: React.ReactNode;
  checkBoxOptions?: CheckboxOption[];
  onToggleFilterOpen?: (filterIndex: number) => void;
  onToggleOptionChecked?: (filterIndex: number | undefined, optionIndex: number) => void;
  handleApplyChanges?: () => void;
  handleCancel?: () => void;
}

const DashboardDrawerForm: FC<DashboardDrawerFormProps> = ({
  open,
  title,
  filterIndex,
  buttonLabel,
  disabledButton = false,
  hideCloseButton = false,
  onClose = () => {},
  buttonOnClick = () => {},
  children,
  checkBoxOptions,
  onToggleOptionChecked = () => {},
  onToggleFilterOpen = () => {},
  handleApplyChanges = () => {},
  handleCancel = () => {},
  ...props
}) => {
  const isIOS = (): boolean => {
    if (typeof window !== 'undefined') {
      if (
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <Drawer
      className="drawer-with-title"
      {...props}
      classes={{ paper: isIOS() ? 'styles.paper_container_iOS' : 'styles.paper_container' }}
      open={open}
      anchor={'bottom'}
      onClose={onClose} // This will now use handleCancel
    >
      <div className="drawer-title">
        <div>{title}</div>
        {!hideCloseButton && (
          <div className="drawer-burger-menu-container" onClick={onClose}>
            <div className="drawer-burger-menu active">
              <div className="bar top"></div>
              <div className="bar middle"></div>
              <div className="bar bottom"></div>
            </div>
          </div>
        )}
      </div>
      <div className="drawer-content">
        {children}

        {checkBoxOptions && checkBoxOptions?.length > 0 && (
          <div className={'drawer-checkbox'}>
            {checkBoxOptions?.map((i, index) => (
              <Checkbox
                id={index?.toString()}
                key={index}
                className={'checkbox'}
                checked={i.checked}
                theme={Theme.GRAY}
                text={i.label}
                onChange={() => onToggleOptionChecked(filterIndex, index)}
              />
            ))}
          </div>
        )}

        <div className="drawer-footer-button">
          {buttonLabel && (
            <Button
              size={ButtonSize.MEDIUM}
              onClick={handleApplyChanges}
              disabled={disabledButton}
              title={buttonLabel}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default DashboardDrawerForm;
